import { Component, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';
import { LocalStorageService } from 'ngx-webstorage';
import { Variables } from '../../../../core/utils/variables';

@Component({
  selector: 'app-ladv-dialog',
  templateUrl: './ladv-dialog.component.html',
  styleUrls: ['./ladv-dialog.component.scss'],
})
export class LadvDialogComponent implements OnInit {
  form: UntypedFormGroup;

  constructor(
    private _dialog: MatDialogRef<LadvDialogComponent>,
    private _formBuilder: UntypedFormBuilder,
    private _storage: LocalStorageService,
  ) { }

  ngOnInit() {
    this._initForm();
  }

  private _initForm() {
    this.form = this._formBuilder.group({
      user: [null, Validators.required],
      password: [null, Validators.required],
    });
  }

  submit() {
    if (this.form.valid) {
      const { user, password } = this.form.value;
      this._storage.store(Variables.STORAGE_AUTH_LADV, { user, password });
      this._dialog.close(this.form.value);
    } else {
      this.form.markAllAsTouched();
    }
  }

  cancel() {
    this._dialog.close();
  }
}
